export default "__VITE_ASSET__VMV7320r__"